<template lang="pug">
.facets
  .top
    .selected-filters(:class="{ empty: !Object.keys(selectedTags).length }")
      //.close(@click="clearFilters(true)")
      .filter.selected(v-for="(v, tag) in selectedTags",
                       @click="toggleTag(tag, true)",
                       :class="{ 'has-includes-excludes': Object.keys(selectedTags).length === 1 }")
        .includes-excludes(v-if="Object.keys(selectedTags).length === 1", @click.stop="setAndOr",
                           :title="`switch to ${ andOr === 'nor' && 'includes' || 'excludes' }`") {{ andOr === 'nor' && 'excludes' || 'includes' }}
        .and-or(@click.stop="toggleAndOr",
                :title="`switch to ${ andOr === 'and' && 'or' || andOr === 'or' && 'nor' || 'and' }`") {{ andOr }}
        .tag {{ tag }}
    //-button-tabs(v-if="!lens")
    //-  button-tab(:id="ns + 'sentiment'")
    //-    template(slot="title") sentiment
    //-    template(slot="content")
    //-      .reset(@click="reset('Sentiment')")
    //-      .sentiment
    //-        slider(v-model="sentiment",
    //-               :max="5",
    //-               :tooltip="false",
    //-               :piecewise="true",
    //-               :piecewiseLabel="true",
    //-               v-bind="{ lazy: true, enableCross: false, piecewiseStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, piecewiseActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
    //-  button-tab.button-tabs-volume(:id="ns + 'volume'", v-if="namespace === 'insightsNS'")
    //-    template(slot="title") volume
    //-    template(slot="content")
    //-      .reset(@click="reset('Volume')")
    //-      .volume
    //-        .slider
    //-          slider(v-model="volume",
    //-                 :max="5",
    //-                 :tooltip="false",
    //-                 :piecewise="true",
    //-                 :piecewiseLabel="true",
    //-                 v-bind="{ lazy: true, enableCross: false, piecewiseStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, piecewiseActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
    //-  button-tab.button-tabs-engagement(:id="ns + 'engagement'", v-else)
    //-    template(slot="title") engagement
    //-    template(slot="content")
    //-      .reset(@click="reset('Engagement')")
    //-      .engagement
    //-        .interestingness(v-if="namespace !== 'insightsNS'")
    //-          .slider
    //-            slider(v-model="interestingness",
    //-                   :max="5",
    //-                   :tooltip="false",
    //-                   :piecewise="true",
    //-                   :piecewiseLabel="true",
    //-                   v-bind="{ lazy: true, enableCross: false, piecewiseStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, piecewiseActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
    //-        .visuality
    //-          .slider
    //-            slider(v-model="visuality",
    //-                   :max="5",
    //-                   :tooltip="false",
    //-                   :piecewise="true",
    //-                   :piecewiseLabel="true",
    //-                   v-bind="{ lazy: true, enableCross: false, piecewiseStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, piecewiseActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
    //-.checkboxes(v-if="!lens")
    //-  checkbox.block(label="includes factoids", v-model="hasFactoids")
    //-  checkbox.block(label="includes directives", v-model="hasDirectives")
    //-.collections(v-if="categories && namespace !== 'insightsNS' && !lens")
    //-  multiselect(v-model="selectedCategories",
    //-              :options="categories",
    //-              :multiple="true",
    //-              :close-on-select="false",
    //-              :clear-on-select="false",
    //-              :preserve-search="true",
    //-              placeholder="Choose Categories"
    //-              selectLabel="+",
    //-              selectedLabel="\u2714",
    //-              deselectLabel="\u00D7")
    //-    template(slot="selection"
    //-             slot-scope="{ values, search, isOpen }")
    //-      span.multiselect__single(v-if="selectedCategories.length && !isOpen") {{ selectedCategories.length }} Categories
    //-    template(slot="option", slot-scope="props")
    //-      .option__desc
    //-        span.option__title(NOTtitle="props.option.count") {{ props.option }}
    //-.sectors(v-if="sectors && namespace !== 'insightsNS' && !lens")
    //-  multiselect(v-model="selectedSectors",
    //-              :options="sectors",
    //-              :multiple="true",
    //-              :close-on-select="false",
    //-              :clear-on-select="false",
    //-              :preserve-search="true",
    //-              placeholder="Choose Sectors"
    //-              selectLabel="+",
    //-              selectedLabel="\u2714",
    //-              deselectLabel="\u00D7")
    //-    template(slot="selection"
    //-             slot-scope="{ values, search, isOpen }")
    //-      span.multiselect__single(v-if="selectedSectors.length && !isOpen") {{ selectedSectors.length }} Sectors
    //-    template(slot="option", slot-scope="props")
    //-      .option__desc
    //-        span.option__title(NOTtitle="props.option.count") {{ props.option }}
  //-.filters.vip(v-if="ns && upperTags && Object.keys(upperTags).length")
  //-  .filter
  //-    .tag Selected themes:
  //-  .filter(v-for="(count, tag) in upperTags",
  //-          @click="toggleTag(tag, true)"
  //-          :class="{ empty: !proxyCount(tag), hasCount: proxyCount(tag) > 1, selected: ns ? selected(tag) : selectedTags[tag] }")
  //-    .tag(:count="proxyCount(tag)") {{ tag }}
  //-    .count(v-if="proxyCount(tag) > 1") &mdash; {{ proxyCount(tag) }}
  //.filters(:class="{ collapse }", v-if="!lens")
  .filters
    .filter-filters
      .clearer(:class="{ hidden: !q }", @click="q = ''")
      input(v-model="q", placeholder="filter")
    .filter(v-for="([tag, count]) in allTags",
            v-show="testWord(tag)",
            @click="toggleTag(tag, true)"
            :class="{ empty: !count, hasCount: count > 1, selected: ns ? selected(tag) : selectedTags[tag] }")
      .tag(:count="count") {{ tag }}
      .count(v-if="count > 1") &mdash; {{ count }}
</template>
<script>
//import { mapGetters, mapActions } from 'vuex';
//import { vuexComputed, vuexComputedNamespace } from '@/helpers';
//import vueSliderComponent from 'vue-slider-component';
//import multiselect from 'vue-multiselect';
//import buttonTabs from './button-tabs';
//import buttonTab from './button-tab';
//import checkbox from './checkbox';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  name: 'facets-lite',
  props: {
    //namespace: { type: String, default: '' },
    themePath: String,
  },
  computed: {
    // ...vuexComputedNamespace(
    //   'sectors',
    //   'selectedSectors',
    //   'categories',
    //   'selectedCategories',
    //   'sentiment',
    //   'interestingness',
    //   'visuality',
    //   'sourcePopularity',
    //   'volume',
    //   'tagsForGrid',
    //   'andOr',
    //   'hasFactoids',
    //   'hasDirectives'
    // ),
    theme() {
      const { themePath, $store: { getters } } = this;
      return getters[themePath];
    },
    selectedTags() {
      return this.theme?.selectedTags;
    },
    tags() {
      return this.theme?.tags;
    },
    andOr() {
      return this.theme?.andOr;
    },
    ns() {
      const { namespace } = this;
      return (namespace && namespace + '/') || '';
    },
    allTags() {
      const { key, $store } = this;
      return $store.getters[key('tagsForGrid', 'allTags')];
    },
    upperTags() {
      return this.$store.getters.selectedAllTags;
    },
    aliases() {
      const {
        $store: {
          getters: { aliases }
        },
        //allTags: items
        tags: items
      } = this;
      //return { ...aliases, ...Object.entries(items).reduce((all, [tag]) => ({ ...all, [tag]: aliases[tag] || tag.toLowerCase() }), {}) };
      return {
        ...aliases,
        ...Object.entries(items).reduce((all, [tag]) => {
          all[tag] = aliases[tag] || tag; //.toLowerCase();
          return all;
        }, {})
      };
    },
    q: {
      get() {
        const {
          ns,
          $store: { getters }
        } = this;
        return getters[ns + 'q'];
      },
      set(value) {
        const {
          ns,
          $store: { dispatch }
        } = this;
        return dispatch(ns + 'q', value);
      }
    },
    qs() {
      return this.q?.split(/\s+/).map(item => new RegExp(item.toLowerCase().replace(/\W/g, '.'), 'i'));
    },
    filteredThemes() {
      const { themesFilter, themes } = this;
      const filters = themesFilter?.split(/\s+/).map(item => new RegExp(item.toLowerCase().replace(/\W/g, '.'), 'i'));
      return Object.values(themes).filter(({ k }) => filters.every(filter => filter.test(k.join('|'))));
    }
  },
  methods: {
    key(nsProp, prop) {
      const { ns } = this;
      return (ns && ns + nsProp) || prop;
    },
    async toggleTag(tag) {
      const { themePath, $store: { dispatch } } = this;
      await dispatch('toggleThemeTag', { themePath, tag });
    },
    async selectSource(tag) {
      await this.$store.dispatch(this.namespace + '/selectSource', tag);
    },
    selected(tag) {
      return this.selectedTags[tag];
    },
    clearFilters(video) {
      console.log('clearFilters', video, ((video && 'video') || 'tweet') + 'Filters');
      this.store.dispatch(((video && 'video') || 'tweet') + 'Filters', {});
    },
    sourceStyle(url) {
      const r = {};
      if (url) {
        r['background-image'] = `url('${ url }')`;
      }
      return r;
    },
    reset(type) {
      const {
        $store: { dispatch },
        ns
      } = this;
      dispatch(`${ ns }reset${ type }`);
    },
    styleBySourceId(source) {
      const r = {};
      const { info } = this.sourceIds?.filter(({ info: { id } }) => id === source).pop() || {};
      if (source && info?.url) {
        r['background-image'] = `url('${ info.url }')`;
      }
      return r;
    },
    toggle() {
      this.facetsCollapsed = !this.facetsCollapsed;
      //this.hub.$emit('facet-collapse');
    },
    toggleAndOr() {
      const { themePath, andOr, $store: { dispatch } } = this;
      dispatch('setThemeAndOr', { themePath, andOr: { and: 'or', or: 'nor', nor: 'and' }[andOr] });
    },
    setAndOr() {
      const { themePath, andOr, $store: { dispatch } } = this;
      dispatch('setThemeAndOr', { themePath, andOr: andOr === 'nor' && 'and' || 'nor' });
    },
    proxyCount(tag) {
      return valueFromEntries(this.tagsForGrid, tag) || 0;
      // return this.allTags[tag]?.count || 0;
      function valueFromEntries(entries, key) {
        return entries?.filter(([k]) => k === key)[0]?.[1];
      }
    },
    testWord(word) {
      const { qs, aliases, selectedTags } = this;
      const { [word]: alias } = aliases;
      /*console.log(qs.join('|'), word, qs.reduce((hit, item) => {
        return hit && item.test(alias || word);
      }, true));*/
      return (
        !qs.length ||
        // to fix dead end bug: force any selected tag to show
        selectedTags[word] ||
        qs.reduce((hit, item) => {
          return hit && item.test(alias || word);
        }, true)
      );
    }
  }//,
  //  components: { slider: vueSliderComponent, multiselect, buttonTabs, buttonTab, checkbox }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.facets {
  position: relative;
  display: none;
  .filter-filters {
    position: relative;
    display: flex;
    padding-left: 1rem;
    input:focus {
      outline: none;
    }
  }
  @include large {
    display: block;
    &.facets-videosNS {
      .top {
        grid-template-columns: auto 23.9rem 15% 15% 1.5%;
      }
    }
    &.facets-documentsNS {
      .top {
        grid-template-columns: auto 25.2rem 15% 15% 15% 1.5%;
      }
    }
    &.facets-insightsNS {
      .top {
        //grid-template-columns: auto 10.5rem 17.75rem 15% 15% 1.5%;
        grid-template-columns: auto 17.75rem 10.5rem 15% 1.5%;
        .checkboxes {
          display: block;
          padding: 1rem 0.5rem;
          margin-right: 0.5rem;
          margin-bottom: -1.7rem;
        }
      }
    }
    &.collapsed {
      .filters:not(.vip) {
        overflow: hidden;
        min-height: 0;
        max-height: 0.25rem;
        padding: 0;
        .filter {
          transition-delay: 0;
          opacity: 0;
        }
      }
      .collapser {
        &::after {
          transform: rotate(90deg) translate3d(1rem, -0.75rem, 0);
        }
      }
      .filter-filters {
        visibility: hidden;
      }
    }
    .collapser {
      cursor: pointer;
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 1;
      &::after {
        color: #777;
        display: inline-block;
        width: 2rem;
        height: 2rem;
        content: '\BB';
        font-size: 2rem;
        transform-origin: center;
        transform: rotate(-90deg);
      }
      transform: translate3d(-2.5rem, 1rem, 0);
    }
    .top {
      padding-bottom: 1rem;
      display: grid;
      grid-template-columns: auto 17.75rem 15% 15% 1.5%;
      border-bottom: 1px solid $brn;
      .checkboxes {
        display: none;
      }
      .collections {
        padding-top: 0.7rem;
      }
      .sectors {
        padding-top: 0.7rem;
      }
      .types {
        padding-top: 0.7rem;
      }
      .info {
        position: relative;
        top: 0.5rem;
        font-style: italic;
        color: #aaa;
        text-align: right;
      }
    }
  }
  .selected-filters,
  .filters {
    display: none;
    @include large {
      //height: auto;
      //max-height: 100vh;
      overflow: auto;
      display: grid;
      grid-template-rows: 100%;
      grid-gap: 2%;
      grid-row-gap: 2%;
      grid-auto-columns: 14%;
      grid-auto-flow: column;
      padding-bottom: 1.2rem;
      &.selected-filters {
        width: 100%;
        display: flex;
        padding: 0.7rem 0.25rem;
        min-height: 2rem;
        max-height: 1.2rem;
        overflow: hidden;
        position: relative;
        &.empty {
          opacity: 0;
        }
        .close {
          height: 3rem;
          width: 3rem;
          &:hover {
            &::after {
              color: black;
            }
          }
          &::after {
            color: #dadada;
            cursor: pointer;
            content: '\D7';
            position: absolute;
            top: -50%;
            right: 0.3rem;
            font-size: 2rem;
            margin-top: -0.05rem;
            transform: translate3d(0, -70%, 0);
          }
        }
        .filter {
          max-width: 14%;
          margin-right: 0.25rem;
          background-color: $brn;
          color: white;
          position: relative;
          margin-top: 0.35rem;
          padding-left: 0.25rem;
          padding-right: 0.8rem;
          max-height: 1.2rem;
          &::after {
            content: '\00d7';
            position: absolute;
            top: 50%;
            right: 0.3rem;
            margin-top: -0.05rem;
            transform: translate3d(0, -50%, 0);
          }
          .and-or {
            display: none;
          }
          .includes-excludes {
            display: none;
          }
          &.has-includes-excludes:first-child {
            position: relative;
            margin-left: 5rem;
            .includes-excludes {
              width: 4.6rem;
              // outline: 1px solid green;
              text-align: center;
              color: #555;
              display: block;
              position: absolute;
              left: -4.5rem;
              cursor: pointer;
              &:hover {
                color: black;
              }
            }
          }
          &:not(:first-child) {
            position: relative;
            margin-left: 2.5rem;
            .and-or {
              width: 1.6rem;
              // outline: 1px solid green;
              text-align: center;
              color: #555;
              display: block;
              position: absolute;
              left: -2.25rem;
              cursor: pointer;
              &:hover {
                color: black;
              }
            }
          }
        }
        .sources {
          margin-left: 1rem;
          display: flex;
          .source {
            cursor: pointer;
            border-radius: 4px;
            margin-top: 0.3rem;
            margin-right: 0.2rem;
            width: 1.9rem;
            height: 1.9rem;
            background: no-repeat center;
            background-size: contain;
            position: relative;
            &:hover {
              &::after {
                box-sizing: border-box;
                //padding-top: 0.2rem;
                text-align: center;
                font-size: 2rem;
                color: white;
                text-shadow: 0 0 2px black;
                content: '\D7';
                position: absolute;
                top: -0.4rem;
                left: 0;
                bottom: 0.4rem;
                right: 0;
              }
            }
          }
        }
      }
    }
    &.filters.collapse {
      .filter.empty {
        display: none;
      }
    }
    .filter {
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: 3px;
      padding: 0.25rem 0.5rem 0.25rem 1rem;
      display: flex;
      margin: 0.125rem 0;
      margin-bottom: -0.25rem;
      white-space: nowrap;
      transition: opacity 200ms ease-in-out 200ms;
      &.selected {
        border-color: $brn;
        .tag[count='0'] {
          opacity: 1;
        }
      }
      .tag {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 0.25rem;
        &[count='0'] {
          opacity: 0.25;
        }
      }
      &.has-count {
        .tag {
          max-width: 80%;
        }
      }
      .count {
        color: #9a9a9a;
      }
    }
  }
  .themes-section {
    position: relative;
    box-sizing: border-box;
    //padding-top: 1.25rem;
    &.nudge-right {
      .search {
        transform: translate3d(21vw, 0, 0);
      }
      .items {
        margin-left: 21vw;
        width: 79vw;
      }
      .selected-themes {
        transform: translate3d(21vw, 0, 0);
      }
    }
    .selected-themes {
      height: 4.7rem;
      margin-bottom: 1.25rem;
      display: flex;
      justify-content: flex-start;
      transform: translate3d(0, 0, 0);
      transition: transform 250ms ease-in-out;
      will-change: transform;
      .theme {
        cursor: pointer;
        width: 3rem;
        flex: 0 0 auto;
        border: 3px solid transparent;
        box-sizing: border-box;
        //padding-bottom: 0.5rem;
        margin: 0.25rem;
        &:hover {
          .details {
            .close {
              opacity: 1;
            }
          }
        }
        &.hide {
          display: none;
        }
        //padding: 0.25rem;
        .details {
          position: relative;
          .close {
            position: absolute;
            top: -0.2rem;
            right: 0.125rem;
            color: white;
            text-shadow: 1px 1px 0 black, -1px -1px 0 black, 0 1px 0 black, 1px 0 0 black, 0 -1px 0 black,
            -1px 0 0 black, 1px 1px 1px black, -1px -1px 1px black, 0 1px 1px black, 1px 0 1px black,
            0 -1px 1px black, -1px 0 1px black;
            opacity: 0;
            transition: opacity 250ms ease-in-out;
            will-change: opacity;
          }
          .bg {
            width: 100%;
            padding-top: 145%;
            background: no-repeat top center;
            background-size: cover;
          }
        }
      }
    }
    .search {
      position: absolute;
      top: 4.75rem;
      left: 0.4rem;
      transform: translate3d(0, 0, 0);
      will-change: transform;
      transition: transform 250ms ease-in-out;
      input {
        &:focus {
          outline: none;
        }
        padding-right: 1rem;
      }
      .close {
        position: absolute;
        top: 0;
        right: 0.5rem;
        cursor: pointer;
      }
    }
    .items {
      width: 100vw;
      overflow: auto;
      display: flex;
      justify-content: flex-start;
      transition: all 250ms ease-in-out;
      padding-left: 3rem;
      position: relative;
      .new-theme {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        font-weight: bold;
        color: orange;
        border-radius: 2px;
        box-sizing: border-box;
        border: 1px solid orange;
        padding: 0.5rem 1rem;
        transform: translate3d(-3rem, 4.1rem, 0) rotate(-90deg);
        transition: all 250ms ease-in-out;
        &:hover {
          background-color: orange;
          color: white;
        }
        .text {
          white-space: nowrap;
        }
      }
      .theme {
        width: 15rem;
        flex: 0 0 auto;
        border: 3px solid transparent;
        box-sizing: border-box;
        padding-bottom: 0.5rem;
        margin: 0.25rem 0.25rem 1.5rem;
        //padding: 0.25rem;
        &.selected {
          border-color: orange;
          .bg {
          }
        }
        .bg {
          width: 100%;
          padding-top: 145%;
          background: no-repeat top center;
          background-size: cover;
        }
        .title {
          margin-top: 0.5rem;
        }
      }
    }
  }
  .filters {
    &.vip {
      grid-template-rows: 100% !important;
      min-height: 1.5rem !important;
      .filter .tag {
        min-height: 1.2rem;
      }
    }
    @include large {
      //height: auto;
      position: relative;
      top: 0.4rem;
      //padding-bottom: 4rem;
      grid-auto-columns: 20%;
      //grid-template-rows: repeat(7, 14%);
      grid-template-rows: repeat(15, 1fr);
      margin-bottom: -1rem;
      height: calc(100vh - 20rem);
      min-height: 8.5rem;
      transition: all 400ms ease-in-out;
      .filter {
        max-height: 1.2rem;
      }
    }
  }
}
</style>
<style lang="scss">
// .option__title in vue multiselect, add overflow ellipsis
/*.option__title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }*/
.tab-content {
  &.modified {
    .reset {
      opacity: 1;
      z-index: 1;
    }
  }
  .reset {
    position: absolute;
    top: 1rem;
    right: 1rem;
    opacity: 0;
    z-index: -1;
    transition: opacity 400ms ease-in-out;
    will-change: opacity;
    &::after {
      cursor: pointer;
      font-size: 0.8rem;
      color: #777;
      content: 'reset';
    }
    &:hover::after {
      color: black;
    }
  }
}
.vue-slider-mark {
  &:first-of-type,
  &:last-of-type {
    &::after {
      white-space: nowrap;
      font-size: 0.7rem;
      color: #777;
      position: absolute;
      top: 240%;
      left: 180%;
    }
    &:last-of-type {
      &::after {
        content: '+';
      }
    }
  }
}
.age {
  .vue-slider-mark:last-of-type {
    &::after {
      transform: translate3d(0.125rem, 0.35rem, 0);
      content: '+';
    }
  }
}
.sentiment {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -1rem;
        color: #555;
        content: 'negative';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -1rem;
        color: #555;
        content: 'positive';
      }
    }
  }
}
.interestingness {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'less';
      }
    }
    &:nth-of-type(3) {
      color: transparent !important;
      &::after {
        position: absolute;
        top: 240%;
        white-space: nowrap;
        font-size: 0.7rem;
        color: #555;
        left: 50%;
        content: 'interesting';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'more';
      }
    }
  }
}
.visuality {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'less';
      }
    }
    &:nth-of-type(3) {
      color: transparent !important;
      &::after {
        position: absolute;
        top: 240%;
        white-space: nowrap;
        font-size: 0.7rem;
        color: #555;
        left: 50%;
        margin-left: 0.65rem;
        content: 'visual';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'more';
      }
    }
  }
}
.volume {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'less';
      }
    }
    &:nth-of-type(3) {
      color: transparent !important;
      &::after {
        position: absolute;
        top: 240%;
        white-space: nowrap;
        font-size: 0.7rem;
        color: #555;
        left: 50%;
        margin-left: 0.65rem;
        content: '';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'more';
      }
    }
  }
}
.source-popularity {
  .slider {
    margin-left: 3rem;
    width: 20rem;
  }
  .vue-slider.vue-slider-ltr {
    .vue-slider-mark {
      &:first-of-type {
        color: transparent !important;
        background-color: orange;
        &::after {
          left: -0.5rem;
          color: #555;
          content: 'less';
        }
      }
      &:nth-of-type(3) {
        color: transparent !important;
        &::after {
          position: absolute;
          top: 240%;
          white-space: nowrap;
          font-size: 0.7rem;
          color: #555;
          left: 50%;
          content: 'popularity';
        }
      }
      &:last-of-type {
        color: transparent !important;
        &::after {
          left: -0.5rem;
          color: #555;
          content: 'more';
        }
      }
    }
  }
}
.button-tab {
  &.button-tabs-sources {
    .tab-content {
      width: 44rem;
    }
  }
  .tab-content {
    .sources {
      box-sizing: border-box;
      padding-top: 0.5rem;
      padding-bottom: 1rem;
      max-height: 70vh;
      overflow: auto;
      .items {
        margin-left: 2.25rem;
        display: grid;
        grid-gap: 0.8rem 0.1rem;
        grid-template-columns: repeat(10, 9.5%);
        .item {
          margin: -3px;
          width: 2.5rem;
          height: 2.5rem;
          background: no-repeat center;
          background-size: contain;
          border: 6px solid transparent;
          border-radius: 3px;
          position: relative;
          &.selected {
            border-color: orange;
            box-shadow: 0 0 2px black;
          }
          &.empty {
            opacity: 0.3;
            overflow: hidden;
            border-color: #dadada;
            &::before {
              content: '\00a0';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
            }
            &::after {
              content: '\00a0';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              /*background-color: rgba(255, 165, 0, 0.5);*/
              /*outline: 3px dashed rgba(255, 165, 0, 0.5);*/
            }
          }
        }
      }
    }
  }
}
</style>
